module.exports = __webpack_public_path__ + "static/logo2-01a37db98c9123b8a347e1203eb5d799.png";